import { URL_CLIENTES } from '../constants';
import TokenService from '../services/Token';
import ViewModeService from '../services/ViewMode';

export const saveUrlParams = (params: URLSearchParams) => {
  const viewMode = params?.get('viewMode') || ViewModeService.getViewMode();
  const utm_campaign = params?.get('utm_campaign');
  const utm_source = params?.get('utm_source');
  const utm_medium = params?.get('utm_medium');
  const utm_content = params?.get('utm_content');
  const utm_term = params?.get('utm_term');
  const utm_track = params?.get('utm_track');
  const utm_variant = params?.get('utm_variant') ?? 'Control';
  const lead_token = params?.get('lead_token');
  const token = params?.get('token');
  const pclient_type = params?.get('pclient_type');
  const device = params?.get('device');
  const isChopApp = params?.get('is_app') === 'true';

  const trackedData: Record<string, any> = {
    lead_token: lead_token ?? TokenService.getLeadToken(),
    utm_campaign: utm_campaign ?? 'EndingLP',
    utm_source: utm_source ?? 'LP',
    utm_medium: utm_medium ?? (viewMode === 'APP' || isChopApp ? 'APP' : 'WEB'),
    utm_content: utm_content ?? 'WEB',
    viewMode: viewMode ?? 'WEB',
    utm_term: utm_term ?? undefined,
    token: token ?? undefined,
    pclient_type: pclient_type ?? undefined,
    device: device ?? undefined,
    utm_track: utm_track,
    utm_variant: utm_variant,
  };

  // Elimina las claves con valor undefined
  Object.keys(trackedData).forEach(
    (key) => trackedData[key] === undefined && delete trackedData[key]
  );

  if (Object.keys(trackedData).length > 0) {
    // Store the tracking data in sessionStorage
    sessionStorage.setItem('utmTrackingData', JSON.stringify(trackedData));
    return trackedData;
  } else {
    return false;
  }
};

export const getUtmParams = (finalParams?: boolean) => {
  const sessionParams = sessionStorage.getItem('utmTrackingData');
  if (sessionParams) {
    const params = JSON.parse(sessionParams);
    let response;
    if (finalParams) {
      // Devolvemos un objeto con los parámetros UTM necesarios, si es para finalizar e ir a clientes serán unos utm concretos:
      response = {
        utm_campaign: 'EndingLP',
        utm_source: 'LP',
        utm_medium:
          (params.viewMode === 'APP' || params.isChopApp ? 'APP' : 'WEB'),
        utm_content: 'WEB',
        pclient_type: params.pclient_type ?? 'lead_token',
        utm_track: params.utm_track,
        utm_variant: params.utm_variant,
      }
    } else {
      // En caso contrario se pasan los parámetros UTM que se hayan recibido al principio 
      response = {
        utm_campaign: params.utm_campaign ?? 'EndingLP',
        utm_source: params.utm_source ?? 'LP',
        utm_medium:
          params.utm_medium ??
          (params.viewMode === 'APP' || params.isChopApp ? 'APP' : 'WEB'),
        utm_content: params.utm_content ?? 'WEB',
        pclient_type: params.pclient_type ?? 'lead_token',
        utm_track: params.utm_track,
        utm_variant: params.utm_variant,
      };
    }
    return response;
  }
  return false;
};

export const getRedirectionUrl = (params: any) => {
  let redirectionUrl;
  if (params) {
    redirectionUrl =
      URL_CLIENTES +
      new URLSearchParams(params).toString();
  } else {
    redirectionUrl = URL_CLIENTES!;
  }
  return redirectionUrl;
};
